import { render, staticRenderFns } from "./ReadMoreBtn.vue?vue&type=template&id=2f6967c6"
import script from "./ReadMoreBtn.vue?vue&type=script&lang=ts"
export * from "./ReadMoreBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports